import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Alert, LinearProgress } from '@mui/material';

import { selectUser, selectOrganization } from 'entities/user/selectors';
import { useChallengesQuery } from 'generated/graphql';
import ChallengePage from './ChallengePage';

const ChallengePageContainer = () => {
  const { id: challengeId } = useParams<{ id: string }>();
  const user = useSelector(selectUser);
  const organization = useSelector(selectOrganization);

  const { data, error, loading } = useChallengesQuery({
    variables: { where: { id: { equals: challengeId } } },
    skip: !user || !challengeId,
  });

  const challenge = data?.challenges?.items?.[0];

  if (error) {
    return <Alert severity="error">An error occurred when fetching the challenge</Alert>;
  }

  if (loading) {
    return <LinearProgress />;
  }

  if (!challenge || !challengeId) {
    return <Alert severity="error">Challenge not found</Alert>;
  }

  return <ChallengePage challenge={challenge} user={user} organization={organization} />;
};

export default ChallengePageContainer;
